import React from "react";
import {
  Box,
  Card,
  CardContent,
  Typography,
  Stepper,
  Step,
  StepLabel,
  Checkbox,
  Alert,
  Button,
  Chip,
  Divider
} from "@mui/material";
import WarningAmberOutlinedIcon from "@mui/icons-material/WarningAmberOutlined";
import DescriptionOutlinedIcon from "@mui/icons-material/DescriptionOutlined";

const steps = [
  "Plan Details",
   "POP Validity",
  "Scope Type",
  "Scope Selection",
 
  "Calculation Rules",
  "Eligibility",
  "Conflict Settings",
  "CP Sign-Off",
  "Review",
];

const OptionCard = ({ selected, onClick, title, subtitle, recommended }) => (
  <Card
    variant="outlined"
    onClick={onClick}
    sx={{
      cursor: "pointer",
      mb: 2,
      borderColor: selected ? "primary.main" : "divider",
      backgroundColor: selected ? "#F5F8FF" : "#fff",
    }}
  >
    <CardContent>
      <Box display="flex" alignItems="flex-start" gap={2}>
        <Checkbox checked={selected} />
        <Box flex={1}>
          <Box display="flex" alignItems="center" gap={1}>
            <Typography fontWeight={600}>{title}</Typography>
            {recommended && (
              <Chip
                label="Recommended"
                size="small"
                color="success"
              />
            )}
          </Box>
          <Typography variant="body2" color="text.secondary">
            {subtitle}
          </Typography>
        </Box>
      </Box>
    </CardContent>
  </Card>
);

const CreatePopPlanStep8 = ({ data, setData, onBack, onNext }) => {
  const select = (value) => {
    setData({ ...data, conflictStrategy: value });
  };

  return (
    <Box p={1}>
 
        
              {/* Back */}
              <Typography
                variant="body2"
                sx={{ mb: 2, cursor: "pointer", color: "text.secondary" }}
                onClick={onBack}
              >
                ← Back to POPs
              </Typography>
        
              {/* Stepper */}
              <Stepper activeStep={6} alternativeLabel sx={{ mb: 3 }}>
                {steps.map((label) => (
                  <Step key={label}>
                    <StepLabel
                      StepIconProps={{
                        sx: {
                          width: 36,
                          height: 36,
                          fontSize: "1rem",
                          "&.Mui-completed": { color: "#2563EB" },
                          "&.Mui-active": {
                            color: "#2563EB",
                            transform: "scale(1.15)",
                          },
                        },
                      }}
                      sx={{
                        "& .MuiStepLabel-label": {
                          fontSize: "0.85rem",
                          mt: 1,
                        },
                      }}
                    >
                      {label}
                    </StepLabel>
                  </Step>
                ))}
              </Stepper>

      <Typography variant="subtitle2" color="text.secondary" mb={2}>
        Step 7 of 9: <strong>Conflict Settings</strong> — AOP handling
      </Typography>

      {/* WARNING BANNER */}
      <Alert
        icon={<WarningAmberOutlinedIcon />}
        severity="warning"
        sx={{ mb: 3 }}
      >
        <Typography fontWeight={600}>
          During this POP period, AOP will be excluded for selected projects.
        </Typography>
        <Typography variant="body2">
          Agreements completed under this POP will not count towards AOP
          achievement.
        </Typography>
      </Alert>

      {/* OPTIONS */}
      <OptionCard
        title="POP Exclusive"
        subtitle="Only POP applies, AOP is excluded"
        recommended
        selected={data.conflictStrategy === "exclusive"}
        onClick={() => select("exclusive")}
      />

      <OptionCard
        title="Allow POP + AOP"
        subtitle="Both POP and AOP can apply simultaneously"
        selected={data.conflictStrategy === "allowBoth"}
        onClick={() => select("allowBoth")}
      />

      {/* FOOTER */}
    {/* FOOTER */}
<Box display="flex" justifyContent="space-between" mt={3}>
  <Button variant="outlined" onClick={onBack}>
    ← Back
  </Button>

  <Button
    variant="contained"
    onClick={onNext}
    disabled={!data.conflictStrategy}   // 👈 disable if nothing selected
  >
    Next →
  </Button>
</Box>
    </Box>
  );
};

export default CreatePopPlanStep8;
